import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttributeDownloadNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.3 9.59998V20.4H2.69999V9.59998H0.299988V21.6C0.299988 22.2633 0.836688 22.8 1.49999 22.8H22.5C23.1633 22.8 23.7 22.2633 23.7 21.6V9.59998H21.3Z"
        fill={color}
      />
      <path
        d="M6 10.8L11.5391 17.4469C11.779 17.7348 12.2211 17.7348 12.461 17.4469L18.0001 10.8H6Z"
        fill={color}
      />
      <path
        d="M12 0.599976C11.0062 0.599976 10.2 1.40628 10.2 2.39998V10.8H13.8V2.39998C13.8 1.40618 12.9938 0.599976 12 0.599976Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttributeDownloadNsk.displayName = 'AttributeDownloadNsk';
